module.exports = __webpack_public_path__ + "media/site_templates/www.cheaptaxaccountants.com.au/images/about_us-64970842d00e64122dcf72f25db163cc.jpg";